import React from "react";
import {
  HiOutlineSquares2X2,
  HiOutlineClipboardDocumentList,
  HiOutlineDocumentChartBar,
  HiOutlineUsers,
  HiOutlineUserGroup,
  HiOutlineBuildingOffice2,
  HiOutlineRectangleGroup,
  HiOutlineCurrencyDollar
} from "react-icons/hi2";

const HEADER_HEIGHT = 68;

function Sidebar({
  setPage,
  user,
  sidebarOpen,
  setSidebarOpen,
  setAdminTab,
  setSuperAdminTab
}) {

  const TAB_URLS = {
    "superadmin-dashboard": "/superadmin",
    "superadmin-create":    "/create-users",
    "superadmin-revenue":   "/revenue",
    "admin-dashboard":      "/admin",
    "admin-users":          "/manageusers",
    "admin-controls":       "/controls",
    "admin-hierarchy":      "/hierarchy",
  };

  const goToPage = (page, tab = "") => {
    if (page === "superadmin" && typeof setSuperAdminTab === "function") {
      setSuperAdminTab(tab || "dashboard");
    }
    if (page === "admin" && typeof setAdminTab === "function") {
      setAdminTab(tab || "dashboard");
    }
    const urlKey = tab ? page + "-" + tab : page;
    const customUrl = TAB_URLS[urlKey];
    setPage(page, customUrl);
    setSidebarOpen(false);
  };

  const sidebarStyle = {
    ...sidebar,
    transform: sidebarOpen ? "translateX(0)" : "translateX(-100%)"
  };

  return (
    <div style={sidebarStyle}>
      <div style={navSection}>

        {/* ================= SUPER ADMIN ================= */}
        {user?.role === "superadmin" && (
          <>
            <SidebarItem
              icon={<HiOutlineSquares2X2 />}
              label="Dashboard"
              onClick={() => goToPage("superadmin", "dashboard")}
            />

            <SidebarItem
              icon={<HiOutlineUserGroup />}
              label="Create Users"
              onClick={() => goToPage("superadmin", "create")}
            />

            <SidebarItem
              icon={<HiOutlineCurrencyDollar />}
              label="Revenue"
              onClick={() => goToPage("superadmin", "revenue")}
            />
          </>
        )}

        {/* ================= MANAGER ================= */}
        {user?.role === "manager" && (
          <>
            <SidebarItem
              icon={<HiOutlineUsers />}
              label="Team Overview"
              onClick={() => goToPage("manager")}
            />
            <SidebarItem
              icon={<HiOutlineDocumentChartBar />}
              label="Reports"
              onClick={() => goToPage("managerReports")}
            />
          </>
        )}

        {/* ================= USER ================= */}
        {user?.role === "user" && (
          <>
            <SidebarItem
              icon={<HiOutlineSquares2X2 />}
              label="Dashboard"
              onClick={() => goToPage("dashboard")}
            />
            <SidebarItem
              icon={<HiOutlineClipboardDocumentList />}
              label="Production Entry"
              onClick={() => goToPage("production")}
            />
            <SidebarItem
              icon={<HiOutlineDocumentChartBar />}
              label="Reports"
              onClick={() => goToPage("reports")}
            />
          </>
        )}

        {/* ================= ADMIN ================= */}
        {user?.role === "admin" && (
          <>
            <SidebarItem
              icon={<HiOutlineSquares2X2 />}
              label="Dashboard"
              onClick={() => goToPage("admin", "dashboard")}
            />
            <SidebarItem
              icon={<HiOutlineUserGroup />}
              label="Manage Users"
              onClick={() => goToPage("admin", "users")}
            />
            <SidebarItem
              icon={<HiOutlineBuildingOffice2 />}
              label="Controls"
              onClick={() => goToPage("admin", "controls")}
            />
            <SidebarItem
              icon={<HiOutlineRectangleGroup />}
              label="Hierarchy"
              onClick={() => goToPage("admin", "hierarchy")}
            />
          </>
        )}

      </div>
    </div>
  );
}

/* ================= ITEM ================= */

function SidebarItem({ icon, label, onClick }) {
  return (
    <button type="button" style={item} onClick={onClick}>
      <span style={itemIcon}>{icon || "•"}</span>
      <span style={itemLabel}>{label}</span>
    </button>
  );
}

/* ================= STYLES ================= */

const sidebar = {
  width: "248px",
  height: `calc(100vh - ${HEADER_HEIGHT}px)`,
  background: "linear-gradient(180deg, #115E59 0%, #0F766E 100%)",
  color: "#FFFFFF",
  position: "fixed",
  left: 0,
  top: `${HEADER_HEIGHT}px`,
  zIndex: 999,
  transition: "transform 0.28s ease",
  boxShadow: "10px 0 28px rgba(15,118,110,0.16)",
  padding: "18px 14px",
  overflowY: "auto",
  borderTopRightRadius: "16px",
  borderRight: "1px solid rgba(255,255,255,0.06)",
  boxSizing: "border-box"
};

const navSection = {
  display: "flex",
  flexDirection: "column",
  gap: "8px"
};

const item = {
  width: "100%",
  border: "1px solid transparent",
  display: "flex",
  alignItems: "center",
  gap: "10px",
  padding: "12px 12px",
  borderRadius: "12px",
  background: "transparent",
  color: "#ECFEFF",
  cursor: "pointer",
  textAlign: "left",
  transition: "all 0.2s ease",
  boxSizing: "border-box"
};

const itemIcon = {
  width: "20px",
  minWidth: "20px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: "20px",
  color: "#FFFFFF"
};

const itemLabel = {
  fontSize: "13px",
  fontWeight: 600,
  lineHeight: 1.2
};

export default Sidebar;